
// Add your custom JS here.
( function( $ ) {

    AOS.init();


    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });

    ///// CHECK IF SCROLLED FROM TOP
    $(document).scroll(function(){
        if($(this).scrollTop() > 50)
        {   
            $('#wrapper-navbar').addClass('off-top');
        }
        if($(this).scrollTop() < 50)
        {   
            $('#wrapper-navbar').removeClass('off-top');
        }
    });


    ///// HEADER IS NOW FIXED - SCROLL FUNCTIONALITY REMOVED
    // Header remains visible at all times


    ///// INTELLIGENT DROPDOWN POSITIONING
    function positionDropdowns() {
        $('.nav-menu > li').each(function() {
            var $menuItem = $(this);
            var $dropdown = $menuItem.children('.sub-menu');
            
            if ($dropdown.length) {
                var menuItemOffset = $menuItem.offset().left;
                var menuItemWidth = $menuItem.outerWidth();
                var dropdownWidth = $dropdown.outerWidth();
                var windowWidth = $(window).width();
                var menuItemCenter = menuItemOffset + (menuItemWidth / 2);
                var windowCenter = windowWidth / 2;
                
                // Remove previous positioning classes
                $menuItem.removeClass('dropdown-left dropdown-right dropdown-center');
                
                // Right side of screen - align dropdown to right edge of parent
                if (menuItemCenter > (windowWidth * 0.66)) {
                    $menuItem.addClass('dropdown-right');
                }
                // Left side of screen - align dropdown to left edge of parent  
                else if (menuItemCenter < (windowWidth * 0.33)) {
                    $menuItem.addClass('dropdown-left');
                }
                // Center of screen - center the dropdown
                else {
                    $menuItem.addClass('dropdown-center');
                }
            }
        });
    }
    
    // Position on page load
    $(document).ready(function() {
        positionDropdowns();
        handleOverflowMenu();
    });
    
    // Reposition on window resize
    $(window).resize(function() {
        positionDropdowns();
        handleOverflowMenu();
    });


    ///// RESPONSIVE OVERFLOW MENU - "MORE" DROPDOWN
    function handleOverflowMenu() {
        var windowWidth = $(window).width();
        
        // Only apply on desktop (below 1329px but above mobile breakpoint 992px)
        if (windowWidth <= 992) {
            // Mobile menu - hide More dropdown
            $('.more-menu-item').remove();
            // Remove any inline styles added by this function
            $('.nav-menu > li').removeAttr('style');
            return;
        }
        
        var $nav = $('.main-navigation .nav-menu');
        var $navItems = $nav.children('li:not(.more-menu-item)');
        var $moreMenuItem = $nav.children('li.more-menu-item');
        
        // Create "More" menu item if it doesn't exist
        if ($moreMenuItem.length === 0) {
            $moreMenuItem = $('<li class="more-menu-item menu-item menu-item-has-children"><a href="#">More<span class="dropdown-indicator"></span></a><ul class="sub-menu"></ul></li>');
            $nav.append($moreMenuItem);
        }
        
        var $moreDropdown = $moreMenuItem.find('.sub-menu');
        
        // Reset - move all items back to main nav (except More itself)
        $moreDropdown.children().each(function() {
            var $item = $(this);
            $item.removeAttr('style'); // Remove inline styles when moving back
            $item.insertBefore($moreMenuItem);
        });
        
        // Check if we need to show More dropdown based on screen width
        if (windowWidth <= 1329) {
            // Move last 3 items to More dropdown
            $navItems = $nav.children('li:not(.more-menu-item)');
            var itemsToMove = Math.min(3, $navItems.length);
            
            for (var i = 0; i < itemsToMove; i++) {
                var $lastItem = $nav.children('li:not(.more-menu-item)').last();
                $lastItem.removeAttr('style'); // Remove inline styles
                $lastItem.prependTo($moreDropdown);
            }
            
            $moreMenuItem.show();
        } else {
            // Hide More dropdown on larger screens
            $moreMenuItem.hide();
        }
    }



    ////// LOGO SWIPER
    if ($(".logo-swiper .swiper-slide").length) {
        var logoSwiper = new Swiper(".logo-swiper", {
            slidesPerView: "auto",
            spaceBetween: 40,
            loop: true,
            autoplay: {
                delay: 0.01,
                disableOnInteraction: false
            },
            speed: 7500,
            disableOnInteraction: false,
            allowTouchMove: false,
            breakpoints: {
                992: {
                    spaceBetween: 80
                }
            }
        });
    }





    ////// TEAM SWIPER
    $(".team-swiper").each(function () {
        var $swiperEl = $(this);
        var slideCount = $swiperEl.find(".swiper-slide").length;
        var $section = $swiperEl.closest(".section-team");
        var maxSlidesPerView = 4;
        var enableLoop = slideCount > maxSlidesPerView;

        if (!enableLoop) {
            $section.find(".team-navigation").hide();
        }

        new Swiper(this, {
            slidesPerView: "auto",
            spaceBetween: 24,
            loop: enableLoop,
            watchOverflow: true,
            navigation: {
                nextEl: $section.find(".team-swiper-next")[0],
                prevEl: $section.find(".team-swiper-prev")[0],
            },
        });
    });




    // PAGE TRANSITIONS
    $("a").click(function(event) {
        // Check if the anchor has a target attribute set to "_blank"
        if ($(this).attr("target") === "_blank") {
            return; // Do nothing if it has target="_blank"
        }

        // Check if the anchor has a "tel:" or "mailto:" href
        var href = $(this).attr("href");
        if (href.startsWith("tel:") || href.startsWith("mailto:")) {
            return; // Do nothing for tel: and mailto: links
        }

        // Check if the anchor has a "#" href
        if (href.indexOf('#') !== -1) {
            // Do nothing for "#" links, but allow them to work
            return;
        }

        // Prevent the default behavior of the anchor tag
        event.preventDefault();

        // Add the "active" class to the element with class "page-transition-in"
        $(".page-transition-in").addClass("active");

        // Delay navigation by 300 milliseconds
        setTimeout(function() {
            window.location.href = href;
        }, 300);
    });



    var image = document.getElementsByClassName('backpar');
    new simpleParallax(image, {
        scale: 1.1
    });




    ////// MENU TOGGLE WITH ANIMATION
    $(".menu-toggle").on("click", function () {
        $(this).toggleClass("toggled");
        $("#wrapper-navbar").toggleClass("active");
        
        if ($("#wrapper-menu").is(":visible")) {
            $("#wrapper-menu").removeClass("show");
            setTimeout(function() {
                $("#wrapper-menu").fadeOut(150);
            }, 300);
        } else {
            $("#wrapper-menu").fadeIn(150, function() {
                $(this).addClass("show");
            });
        }
    });


    ////// MOBILE MENU - Add chevron icons and toggle functionality
    // Only restructure menu items on mobile (when wrapper-menu is visible)
    function setupMobileMenuToggles() {
        $("#wrapper-menu .menu-item-has-children").each(function() {
            var $menuItem = $(this);
            var $link = $menuItem.children('a').first();
            
            // Only restructure if not already done
            if (!$menuItem.find('.dropdown-toggle-icon').length) {
                // Wrap link text in span (keep link functional for navigation)
                var linkHtml = $link.html();
                $link.html('<span class="menu-text">' + linkHtml + '</span>');
                
                // Add icon as sibling to the link (not inside it)
                $link.after('<span class="dropdown-toggle-icon"><i class="icon-chevron-down"></i></span>');
            }
        });
    }

    // Run on load
    setupMobileMenuToggles();

    // Handle icon click to toggle dropdown
    $("#wrapper-menu").on("click", ".dropdown-toggle-icon", function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $parentLi = $(this).closest('.menu-item-has-children');
        
        // Toggle active class
        $parentLi.toggleClass("active");
        
        // Close other open dropdowns (accordion style)
        $parentLi.siblings(".menu-item-has-children.active").removeClass("active");
    });



    ////// TEAM MEMBER TOGGLE
    $(".team-member").on("click", function () {
        var memberId = $(this).attr("teamindex");
        $("#team-member-popup-" + memberId + "").fadeIn(150);
    });

    $(".team-member-popup .close").on("click", function () {
        $(".team-member-popup").fadeOut(150);
    });


    ///// STATS COUNTER ANIMATION
    function animateStatValue($valueEl, target, duration) {
        var startTime = null;
        var startVal = 0;

        function easeOutCubic(t) {
            return 1 - Math.pow(1 - t, 3);
        }

        function step(timestamp) {
            if (!startTime) {
                startTime = timestamp;
            }
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var current = Math.round(startVal + (target - startVal) * easeOutCubic(progress));
            $valueEl.text(current);

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                $valueEl.text(target);
            }
        }

        window.requestAnimationFrame(step);
    }

    if ($('.section-stats .stat-item').length && 'IntersectionObserver' in window) {
        var statsObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                var $item = $(entry.target);
                var $valueEl = $item.find('.stat-value');
                var target = parseInt($item.data('count'), 10) || 0;
                var duration = parseInt($item.data('duration'), 10) || 2000;

                animateStatValue($valueEl, target, duration);
                observer.unobserve(entry.target);
            });
        }, { threshold: 0.35 });

        $('.section-stats .stat-item').each(function() {
            statsObserver.observe(this);
        });
    } else if ($('.section-stats .stat-item').length) {
        $('.section-stats .stat-item').each(function() {
            var $item = $(this);
            var target = parseInt($item.data('count'), 10) || 0;
            $item.find('.stat-value').text(target);
        });
    }


    ///// FAQ TOGGLE
    $(".section-faq .faq-item").on("click", function () {
        if (!$(this).hasClass("active")) {
            $(".section-faq .faq-item.active .answer").slideUp(150);
            $(".section-faq .faq-item.active").removeClass("active");
            $(this).addClass("active");
            $(this).children(".answer").slideDown(150);
        } else {
            $(this).removeClass("active");
            $(this).children(".answer").slideUp(150);
        }
    });



})(jQuery);
